import {ReactNode} from "react";
import {Link, useNavigate} from "react-router-dom";
import "./navigator.css";

interface NavigatorProps {
    children: ReactNode | ReactNode[];
    to: string;
    blank?: boolean;
}

const Navigator = ({ children, to, blank = false }: NavigatorProps) => {
    return <Link className="navigator-link" to={to} target={blank ? '_blank' : '_self'}>{children}</Link>
}

export default Navigator;